import { fetchAPI } from "@/utils/fetchAPI";

export type ProductName =
  | "Forfait avec Engagement"
  | "Gestion+ avec Engagement"
  | "Saisie PREMIER"
  | "Gestion+"
  | "eCofiCoffre";

export type CofidocContract = {
  productName?: ProductName;
  typeProduit?: number;
  typeFacturation?: number;
  productBase?: number;
  percentage?: number;
  description?: string;
  active?: boolean;
  montant?: string;
  subscriptionDate?: Date;
  terminationDate?: Date;
  commitmentDuration?: number;
  annualTurnover?: number;
  annualTurnoverMin?: number;
  annualTurnoverMax?: number;
  monthlyTurnoverMin?: number;
  monthlyTurnoverMax?: number;
};

type FetchCofidocContractsParams = {
  username?: string | null;
  email?: string | null;
};

export async function fetchCofidocContracts({ username, email }: FetchCofidocContractsParams = {}) {
  try {
    const queryParams = new URLSearchParams();
    if (username) queryParams.append("username", username);
    if (email) queryParams.append("email", email);

    const queryString = queryParams.toString();
    const url = `/account/contracts${queryString ? `?${queryString}` : ""}`;

    const res = await fetchAPI({
      url,
      options: {
        method: "GET",
      },
    });

    return res;
  } catch (error) {
    throw new Error();
  }
}
